<template>
  <a :href="link" @click.prevent="onClicked" :class="['btn', 'btn-white', buttonSize]">
    <i v-if="icon" :class="['far', icon]"></i> {{title}}
  </a>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: '#'
    },
    buttonSize: {
      type: String,
      default: 'btn-xs'
    },
    title: String
  },
  methods: {
    onClicked(evt) {
      this.$emit('click', evt)
    }
  }
}
</script>